import {
    SET_USER_PURPOSES,
    ADD_USER_PURPOSE,
    REMOVE_USER_PURPOSE,
    SET_EXPIRE_TIME_ALL_POSITIVE,
    SET_EXPIRE_TIME_ONE_NEGATIVE,
    SET_COOKIE_NAME,
    SET_COOKIE_EXPIRE_TIME,
    SET_USER_CONSENT,
    SET_USER_FEATURES,
    SET_USER_VENDORS,
    SET_USER_CUSTOM_PURPOSES,
} from "../action_types";



export const setUserConsentReducer = (consent = {
    purposes: [],
    custom: [],
}, action) => {
    switch (action.type) {
        case SET_USER_CONSENT:
            return Object.assign({}, consent, action.consent);

        case SET_USER_PURPOSES:
            return Object.assign({}, consent, action.consent);

        case REMOVE_USER_PURPOSE:
            return Object.assign({}, consent, { purposes: consent.purposes.filter(e => e !== action.id) });

        case ADD_USER_PURPOSE:
            return Object.assign({}, consent, { purposes: consent.purposes.concat(action.id) });

        case SET_USER_CUSTOM_PURPOSES:
            return Object.assign({}, consent, action.consent);

        case SET_USER_FEATURES:
            return Object.assign({}, consent, action.consent);

        case SET_USER_VENDORS:
            return Object.assign({}, consent, action.consent);

        default:
            return consent;
    }
};

export const setCookieNameReducer = (cookieName = 'euconsent', action) => {
    switch (action.type) {
        case SET_COOKIE_NAME:
            return action.cookieName;

        default:
            return cookieName;
    }
};

export const setCookieExpireTimeReducer = (time = 1000 * 60 * 60 * 24 * 366, action) => {
    switch (action.type) {
        case SET_COOKIE_EXPIRE_TIME:
            return action.expireTime;

        default:
            return time;
    }
}

export const expireTimePositiveReducer = (time = 1000 * 60 * 60 * 24 * 365, action) => {
    switch (action.type) {
        case SET_EXPIRE_TIME_ALL_POSITIVE:
            return action.expireTime;

        default:
            return time;
    }
};

export const expireTimeOneNegativeReducer = (time = 1000 * 60 * 60 * 24 * 7, action) => {
    switch (action.type) {
        case SET_EXPIRE_TIME_ONE_NEGATIVE:
            return action.expireTime;

        default:
            return time;
    }
};